/* eslint-disable react/prop-types */
import React from 'react';
import { Icon } from '@fiverr-private/fit';
import { l_arrow_right } from '@fiverr-private/icons';
import { green_700 } from '@fiverr-private/sass/helpers/index';
import { default as MediaAsset } from '@fiverr-private/cms_ui/src/content_types/MediaAsset/component/MediaAsset';
import styles from './styles.module.scss';

const LinkWrapper = ({ link, children }) =>
    link ? (
        <a href={link} target="_blank" rel="noreferrer">
            {children}
        </a>
    ) : (
        children
    );

export const PortraitTile = ({ ...props }) => (
    <div className="portrait-tile">
        {props.mediaAsset && (
            <LinkWrapper link={props.webLink}>
                <div className={`image-wrapper ${props.mediaAsset.previewUrl ? 'video' : ''}`}>
                    <MediaAsset {...props.mediaAsset} />
                </div>
            </LinkWrapper>
        )}

        {props.subtitle && <p className="date m-b-12">{props.subtitle}</p>}
        {props.title && (
            <LinkWrapper link={props.webLink}>
                <h5 className={styles.title}>{props.title}</h5>
            </LinkWrapper>
        )}
        {props.artCredit && (
            <LinkWrapper link={props.webLink}>
                <p className="continue-text">
                    {props.artCredit}
                    <Icon color={green_700}>{l_arrow_right}</Icon>
                </p>
            </LinkWrapper>
        )}
    </div>
);
